import { render } from "./termsConditionBannerComponent.vue?vue&type=template&id=31de4cbe"
import script from "./termsConditionBannerComponent.vue?vue&type=script&lang=js"
export * from "./termsConditionBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__